import { render, staticRenderFns } from "./MovieOrder.vue?vue&type=template&id=bfa6b418&scoped=true"
import script from "./MovieOrder.vue?vue&type=script&lang=js"
export * from "./MovieOrder.vue?vue&type=script&lang=js"
import style0 from "./MovieOrder.vue?vue&type=style&index=0&id=bfa6b418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa6b418",
  null
  
)

export default component.exports